import React, { useContext } from "react"
import { UserInterfaceContext } from "../context/UserInterfaceContext"
import InformationIcon from "../icons/information"

function ImportantAlerts(): JSX.Element | null {
  const { importantAlertsJson } = useContext(UserInterfaceContext)
  // DO NOT REMOVE THIS COMMENT - possible tailwind bg colors: bg-error bg-info bg-normal bg-success
  // console.log({ importantAlertsJson })
  return importantAlertsJson && importantAlertsJson.length > 0 ? (
    <>
      {importantAlertsJson.map((alert, index) => (
        <div
          key={index}
          className={`alerts-container bg-${alert.type} text-white`}
        >
          <div className="alert main-container px-4 lg:px-14 py-2 text-xs lg:text-base leading-4 flex gap-4 items-center">
            <InformationIcon className="w-4 h-4 lg:w-8 lg:h-8 shrink-0 text-white" />
            <div dangerouslySetInnerHTML={{ __html: alert.post_content }} />
          </div>
        </div>
      ))}
    </>
  ) : null
}

export default ImportantAlerts
